import type { ComboboxItem, OptionsFilter } from '@mantine/core'
import type { ReactNode } from 'react'
import { searchStringFromStringWithSpaces } from './searchStringFromStringWithSpaces'

const itemMatches = (search: string, item: ComboboxItem, group?: ReactNode) => {
  const fullStringToSearch = `${item.label ?? ''}${typeof group === 'string' ? group : ''}`

  return searchStringFromStringWithSpaces(search, fullStringToSearch)
}

export const mantineSelectSearchFilterProp: OptionsFilter = ({ options, search }) => {
  const result: typeof options = []

  options.forEach((option) => {
    if ('group' in option) {
      const items = option.items.filter((item) => itemMatches(search, item, option.group))

      if (items.length > 0) result.push({ group: option.group, items })
    } else if (itemMatches(search, option)) {
      result.push(option)
    }
  })

  return result
}
